export function toNumber(value: string | boolean | number | null | undefined) {
  if (!value) return 0;
  const convertedValue = +value;
  if (!convertedValue) return 0;
  return convertedValue;
}